export default function initCollapse() {
  const paymentCollapsible = document.getElementById('payment-method');

  if (paymentCollapsible) {
    paymentCollapsible.addEventListener('hidden.bs.collapse', () => {
      const radios = paymentCollapsible.getElementsByName('payment-method');

      for (i = 0; i < radios.length; i++) {
        radios[i].checked = false;
      }
    });
  }
}
